import { render, staticRenderFns } from "./FileSettlement.vue?vue&type=template&id=b78f6e4e"
import script from "./FileSettlement.vue?vue&type=script&lang=js"
export * from "./FileSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports